import api from "../utils/api-axios"

export const ratingApi = {
    checkPendingRatings: async () => {
        const response = await api.get('/exchanges/pending-rating');
        return response.exchange; // Return the exchange data directly
    },

    submitExchangeRating: async (exchangeId, rating) => {
        const response = await api.post('/exchanges/submit-rating', {
            exchangeId,
            rating
        });
        return response;
    },

    setRatingReminder: async (exchangeId) => {
        const response = await api.post('/exchanges/remind-later', {
            exchangeId
        });
        return response;
    }
}